import Index from '../components/doctor/index'
import HomePage from '../components/doctor/homePage'
import CaseList from '../components/doctor/caselist/caseList'
import DzdCaseList from '../components/doctor/caselist/dzdCaseList'
import YzdCaseList from '../components/doctor/caselist/yzdCaseList'
import CaseSearch from '../components/base/caseSearch/caseSearch'
import Diagnosis from '../components/doctor/diagnosis/diagnosis'
import PdfView from '../components/base/pdf/pdfView'
import PersonInfo from '../components/doctor/user/personInfo'
import PersonInfoDetail from '../components/doctor/user/personInfoDetail'
import PersonInfoEdit from '../components/doctor/user/personInfoEdit'
import CellReportEdit from '../components/doctor/report/cellReportEdit'
import TissueReportEdit from '../components/doctor/report/tissueReportEdit'
import MedicalUnionPush from '../components/doctor/caselist/list/medicalUnionPush'
import MedicalUnionList from '../components/doctor/caselist/medicalUnionList'
import MedicalCaseList from '../components/doctor/caselist/medicalCaseList'
import CellAdoptReport from '../components/doctor/report/cellAdoptReport'
import TissueAdoptReport from '../components/doctor/report/tissueAdoptReport'
import MessageCenter from '../components/doctor/messageCenter/messageCenter'
import Collection from '../components/doctor/collection/collectionCaseList/collection'
import CaseShare from '../components/doctor/share/caseFromShare'
import WaitingReview from '../components/doctor/user/waitingReview'
import SubmitInformation from '../components/doctor/user/submitInformation'
export default [
  {
    path: '/submitInformation',
    name: 'SubmitInformation',
    meta: {
      title: '提交审核资料'
    },
    component: SubmitInformation
  }, {
    path: '/waitReview',
    name: 'WaitReview',
    meta: {
      title: '资料审核中'
    },
    component: WaitingReview
  }, {
    path: '/doctor',
    name: 'Index',
    component: Index,
    redirect: 'index',
    children: [
      {
        path: 'index',
        name: 'HomePage',
        meta: {
          title: '首页'
        },
        component: HomePage
      }, {
        path: 'caselist',
        name: 'CaseList',
        meta: {
          title: '样本列表'
        },
        component: CaseList,
        children: [
          {
            path: 'dzdcaselist',
            name: 'DzdCaseList',
            meta: {
              title: '未报告',
              keepAlive: true // 需要被缓存
            },
            component: DzdCaseList
          }, {
            path: 'yzdcaselist',
            name: 'YzdCaseList',
            meta: {
              title: '已报告',
              keepAlive: true // 需要被缓存
            },
            component: YzdCaseList
          }, {
            path: 'medicalUnionList',
            name: 'MedicalUnionList',
            meta: {
              title: '医联体',
              keepAlive: true // 需要被缓存
            },
            component: MedicalUnionList
          }
        ]
      }
    ]
  }, {
    path: '/casesearch/:caselistype',
    name: 'casesearch',
    meta: {
      title: '样本搜索'
    },
    component: CaseSearch
  }, {
    path: '/diagnosis/:type/:caseid',
    name: 'diagnosis',
    meta: {
      title: '诊断中'
    },
    component: Diagnosis
  }, {
    path: '/cellreportedit/:type/:caseid/:reportid',
    name: 'CellReportEdit',
    meta: {
      title: '细胞报告结果'
    },
    component: CellReportEdit
  }, {
    path: '/medicalunionpush/:caseid',
    name: 'MedicalUnionPush',
    meta: {
      title: '推送病例'
    },
    component: MedicalUnionPush
  }, {
    path: '/medicalcaselist/:caseid',
    name: 'MedicalCaseList',
    meta: {
      title: '推送病例'
    },
    component: MedicalCaseList
  }, {
    path: '/tissuereportedit/:type/:caseid/:reportid',
    name: 'TissueReportEdit',
    meta: {
      title: '组织报告结果'
    },
    component: TissueReportEdit
  }, {
    path: '/celladoptreport/:caseid/:reportid',
    name: 'CellAdoptReport',
    meta: {
      title: '采纳会诊细胞报告'
    },
    component: CellAdoptReport
  }, {
    path: '/tissueadoptreport/:caseid/:reportid',
    name: 'TissueAdoptReport',
    meta: {
      title: '采纳会诊组织报告'
    },
    component: TissueAdoptReport
  }, {
    path: 'reportdetail',
    name: 'reportdetail',
    meta: {
      title: '查看报告',
      keepAlive: false // 不需要被缓存
    },
    component: PdfView
  }, {
    path: '/collection',
    name: 'Collection',
    meta: {
      title: '收藏页面'
    },
    component: Collection
  }, {
    path: '/messagecenter',
    name: 'MessageCenter',
    meta: {
      title: '消息中心'
    },
    component: MessageCenter
  }, {
    path: '/personinfo',
    name: 'PersonInfo',
    component: PersonInfo,
    children: [
      {
        path: 'personInfoDetail',
        name: 'PersonInfoDetail',
        meta: {
          title: '个人信息'
        },
        component: PersonInfoDetail
      }, {
        path: 'edit',
        name: 'PersonInfoEdit',
        meta: {
          title: '编辑个人信息'
        },
        component: PersonInfoEdit
      }
    ]
  }, {
    path: '/caseShare/:caseid',
    name: 'caseShare',
    meta: {
      title: '浏览病例'
    },
    component: CaseShare
  }
]



// WEBPACK FOOTER //
// ./src/router/doctor.js